import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { BarService } from 'app/services/dal/bar.service';
import { from, of } from 'rxjs';
import { catchError, concatMap, filter, map, mergeMap, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import * as BarActions from './actions'
import { ToastService } from '../../services/toast.service';
import { trackLoading } from '../effect-helpers';
import * as fromBar from './reducer';




@Injectable()
export class BarEffects {

  constructor(
    private actions$: Actions,
    private store: Store,
    private barService: BarService,
    private toastService: ToastService) { }

  selectBar$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(BarActions.loadBar),
        withLatestFrom(
          this.store.select(fromBar.selectBar),
          this.store.select((state: any) => state.loading?.['bar_' + 'current'] || false)
        ),
        filter(([action, existingBar, isLoading]) => {
          if (action.forceRefresh) return true;
          if (isLoading) {
            return false;
          }
          if (existingBar && existingBar.id) {
            return false;
          }
          return true;
        }),
        switchMap(([action]) =>
          trackLoading(
            this.store,
            'bar',
            'current',
            this.barService.getItem(action.barId).pipe(
              filter((data) => Boolean(data)),
              map(bar => BarActions.loadBarSuccess({ bar: bar })),
              catchError(error => of(BarActions.loadBarFailure({ error })))
            )
          )
        )
      );
  });

  handleFetchError$ = createEffect(
    () => {
      return this.actions$
        .pipe(
          ofType(BarActions.loadBarFailure),
          tap((action) => {
            this.toastService.error(action.error)
          }),
        )
    },
    { dispatch: false }
  );

  updateBar$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(BarActions.updateBar),
        concatMap((action) => from(this.barService.update(action.bar))
          .pipe(
            map(() => {

              const result = BarActions.updateBarSuccess({ bar: action.bar })
              this.toastService.saveSuccess();
              return result;

            }),
            catchError(error => {
              this.toastService.error(error);
              return of(BarActions.updateBarFailure({ error }))
            })
          )
        )
      );
  });


  softUpdate$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(BarActions.softUpdate),
        mergeMap((action) => from(this.barService.softUpdate(action.id, action.data, action.uid))
          .pipe(
            map(() => {
              this.toastService.saveSuccess();
              return BarActions.softUpdateSuccess({ id: action.id, data: action.data })
            }),
            catchError((error) => {
              return of(BarActions.softUpdateFailure({ error }))
            })
          )
        )
      );
  });

  softUpdateSuccess$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(BarActions.softUpdateSuccess),
        tap(() => {
          this.toastService.saveSuccess();
        }),
      );
  }, { dispatch: false });


  softUpdateFailure$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(BarActions.softUpdateFailure),
        tap(({ error }) => {
          this.toastService.error(JSON.stringify(error));
        })
      );
  }, { dispatch: false });





}
